import { Row, Col } from 'react-bootstrap';
import authCentral from "../../../services/authCentral";
import useOriginApp from '../../../services/useOriginApp';
import { ButtonLink, TitleWMutedRow } from '../../../sitel/demon/ui/atoms';
import { getOauthLink } from '../../../services/authCentral';
import { MEDSTAR_ASSOCIATION_TYPE__UNKNOWN, MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE } from '../../../sitel/commons/utilities/medstarAssociationType';

export default function WhoAreYou() {
  const OriginApp = useOriginApp();

  if(OriginApp.loginPage){
    return customLogingPages[OriginApp.loginPage]();
  }

  //User is already logged in. Redirecting him
  //to the app. Let the app decide wether the user has access or not
  if(authCentral.getCurrentUser()){
  	window.location.href = OriginApp.url;
	  return null;
  }

  //Hiding SP login and redirecting to SSO
  if(OriginApp.ssoOnly && OriginApp.ssoOnly === true){
    window.location.href = (getOauthLink(OriginApp.path));
    return null;
  }

  return (
    <>
      <TitleWMutedRow muted='For employees with network access'>Current MedStar Health Employees</TitleWMutedRow>
      <Row>
        <Col>
          <a className='btn btn-warning' style={{ width: '100%' }} href={getOauthLink(OriginApp.path)}>
            Login With MedStar Health Email
          </a>
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>

      <TitleWMutedRow muted='For MedStar Health New Hire'>MedStar Health Applicants</TitleWMutedRow>
      <Row>
        <Col>
          <ButtonLink link={`../new/${MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE}`} btnStyle='btn-medstar-primary'>
            Create Account
          </ButtonLink>
        </Col>
      </Row>
      <Row>
        <Col>
          <ButtonLink link={`login/${MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE}`} btnStyle='btn-medstar-outline'>
            Log In
          </ButtonLink>
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>

      <TitleWMutedRow muted='For contractors, vendors, students, and other non-MedStar Health-employed individuals'>Non-MedStar Health Employees</TitleWMutedRow>
      <Row>
        <Col>
          <ButtonLink link={`../new/${MEDSTAR_ASSOCIATION_TYPE__UNKNOWN}`} btnStyle='btn-medstar-primary'>
            Create Account
          </ButtonLink>
        </Col>
      </Row>
      <Row>
        <Col>
          <ButtonLink link={`login/${MEDSTAR_ASSOCIATION_TYPE__UNKNOWN}`} btnStyle='btn-medstar-outline'>
            Log In
          </ButtonLink>
        </Col>
      </Row>
    </>
  );
}



//This will reside here for the time being.

const customLogingPages = {
  sitelms: function(){
    return (
      <>
        <TitleWMutedRow muted='For employees with network access'>Welcome to SiTELMS</TitleWMutedRow>
        <Row>
          <Col>
            <a className='btn btn-warning' style={{ width: '100%' }} href={process.env.REACT_APP_SITELMS_SSO_LINK}>
              Login With MedStar Health Email
            </a>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
      </>
    );
  }
};